import baseURL from "../common/axios";
class agentService {
  //To Insert Agent-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Agent/Create", dataModel);
  }
  //To Update Agent-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Agent/Update", dataModel);
  }
  //To Delete Agent-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("Agent/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "Agent/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get Agent List-->MOPCRM API
  getList(clientId) {
    return baseURL.httpMSMOPCRMUrl.get("Agent/List?ClientId=" + clientId);
  }

  AgentListWithBranch(ClientId) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Agent/AgentListWithBranch?ClientId=" + ClientId + ""
    );
  }
  GroupAgentListWithBranch(OrganizationId, AgentId) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Agent/GroupAgentListWithBranch?OrganizationId=" +
        OrganizationId +
        "&AgentId=" +
        AgentId +
        ""
    );
  }
  //To Get Agent List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Agent/Get?id=" + Id + "");
  }
  DidNumberList() {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get("Agent/DidNumberList");
  }
}
export default new agentService();
